export default __webpack_public_path__ + "assets/images/af3577c02938dd80ea41da86547a8cb4.png";